import { render, staticRenderFns } from "./UserPermissionsTable.vue?vue&type=template&id=46cb7d00&scoped=true&"
import script from "./UserPermissionsTable.vue?vue&type=script&lang=js&"
export * from "./UserPermissionsTable.vue?vue&type=script&lang=js&"
import style0 from "./UserPermissionsTable.vue?vue&type=style&index=0&id=46cb7d00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cb7d00",
  null
  
)

export default component.exports